import React, { useEffect } from "react";
import styled from "styled-components";
import Modal from "common/Modal";
import { useNavigate } from "react-router-dom";
import getIconFromId from "utils/getIconFromId";
import { List, KeyboardArrowRight, CheckCircle } from "@material-ui/icons";

const ListOfEventsBlock = styled.div`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  height: calc(100% - 85px);
`;
const RowTh = styled.div`
  display: flex;
  width: calc(100% - 90px);
  font-size: 14px;
  position: sticky;
  background-color: #fff;
  z-index: 9999;
  min-height: 20px;
  top: 0;
  align-self: flex-start;
  padding: 18px 45px 10px 45px;
  color: #546472;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  & > div:nth-child(1) {
    width: 40%;
  }
  & > div:nth-child(2) {
    width: 30%;
  }
  & > div:nth-child(3) {
    width: 30%;
    text-align: right;
  }
`;
const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;
const FlexHolderStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;
const ImgOverlay = styled.div`
  background-color: #ffffff;
  width: 20px;
  height: 30px;
  position: absolute;
  z-index: 99;
  left: -20px;
`;
const ImgHolder = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  z-index: 9;
  left: -25px;
`;

const RowTd = styled.div`
  display: flex;
  width: 100%;
  width: calc(100% - 90px);
  padding: 15px 45px 15px 45px;
  min-height: 20px;
  flex-flow: row nowrap;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  &:hover {
    background-color: #f1f1f1;
  }
  &:hover > ${FlexHolderStart} > ${ImgHolder} > ${ImgOverlay} {
    background-color: #f1f1f1;
  }
  & > div:nth-child(1) {
    width: 40%;
  }
  & > div:nth-child(2) {
    width: 30%;
  }
  & > div:nth-child(3) {
    text-align: right;
    width: 30%;
  }
`;
const EventsHolder = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
`;
const Img = styled.img`
  background: transparent;
  margin-left: -20px;
  width: 100%;
`;
const TitleHolder = styled.div`
  width: calc(100% - 10px);
  display: flex;
  align-items: center;
`;
const Title = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledKeyboardArrowRight = styled(KeyboardArrowRight)`
  position: absolute;
  right: -25px;
  top: 0px;
`;
const EventDescription = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

function getIconForEvent(channel, channels, forColor) {
  const ch = channels.find(ch => ch.id === channel);
  // const icon = getIconFromId(ch.icon);
  if (forColor) {
    return `#${ch.color}`;
  }
  return ch.icon;
}

function EventsList({
  setToggleModal,
  toggleModal,
  filteredEvents,
  channels,
  setUpdateEvents,
  updateEvents,
  isLoadingEvents,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    setUpdateEvents(updateEvents + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      modalTitle="Ereignisse"
      isOpen={toggleModal === 2}
      onRequestClose={() => setToggleModal(0)}
      Icon={List}
    >
      <ListOfEventsBlock>
        <RowTh>
          <div title="Unternehmen" alt="Unternehmen">
            Unternehmen
          </div>
          <div title="Ereignis" alt="Ereignis">
            Ereignis
          </div>
          <div title="Datum" alt="Datum">
            Datum
          </div>
        </RowTh>
        {isLoadingEvents ? (
          <div>Ereignisse werden geladen…</div>
        ) : (
          <EventsHolder>
            {filteredEvents.length > 0 ? (
              filteredEvents.map((e, index) => (
                <React.Fragment key={index}>
                  <RowTd
                    onKeyPress={event => {
                      if (event.key === "Enter") {
                        navigate({ pathname: `/map/event/${e.id}` });
                        e.read = true;
                      }
                    }}
                    onClick={() => {
                      navigate({ pathname: `/map/event/${e.id}` });
                      e.read = true;
                    }}
                    tabIndex={0}
                  >
                    <FlexHolderStart>
                      <ImgHolder>
                        <ImgOverlay />
                        <Img
                          style={{
                            filter: `opacity(1) drop-shadow(20px 0px 0px ${getIconForEvent(
                              e.channel,
                              channels,
                              {
                                forColor: true,
                              }
                            )})`,
                          }}
                          src={getIconFromId(getIconForEvent(e.channel, channels))}
                          alt="company-img"
                        />
                      </ImgHolder>
                      <TitleHolder>
                        <Title title={e.name} alt={e.name}>
                          {e.name}
                        </Title>
                        {e.read ? (
                          <span
                            title="gelesen"
                            style={{
                              marginLeft: "5px",
                              color: "#366b14",
                              height: "20px",
                            }}
                          >
                            <CheckCircle fontSize="small" />
                          </span>
                        ) : null}
                      </TitleHolder>
                    </FlexHolderStart>
                    <EventDescription title={e.description} alt={e.description}>
                      {e.description}
                    </EventDescription>
                    <FlexHolder title={e.date} alt={e.date}>
                      {e.date}
                      <StyledKeyboardArrowRight fontSize="small" />
                    </FlexHolder>
                  </RowTd>
                </React.Fragment>
              ))
            ) : (
              <div>No events were found</div>
            )}
          </EventsHolder>
        )}
      </ListOfEventsBlock>
    </Modal>
  );
}

export default EventsList;
